import { create } from "zustand";
import {
	ContactsAdvancedFilterActions,
	ContactsAdvancedFilterState,
} from "./types";

/**
 * Whether the advanced filter dialog is open. It lives outside the Contacts panel so the keyboard
 * shortcut can open it from anywhere in the app, which also means the panel has to close it on the
 * way out: switching tabs unmounts the panel, and a flag left set would reopen the dialog by itself.
 */
export const useContactsAdvancedFilterStore = create<
	ContactsAdvancedFilterState & ContactsAdvancedFilterActions
>((set) => ({
	isDialogOpen: false,
	setDialogOpen: (isDialogOpen: boolean): void => set({ isDialogOpen }),
}));
